<template>
    <div id="noviceGuide">
        <Headers :headersText='headersText'></Headers>
         <!-- 选择方式 -->
        <div class="selectMode">
            <div class="modesBox" :style="{borderBottom:(selectMode == 0 ? '3px solid #E50113' : '')}" @click="chooseMode(0)">
                <div class="modes">
                    <span>常见问题</span>
                </div>
            </div>
            <div class="modesBox" :style="{borderBottom:(selectMode == 1 ? '3px solid #E50113' : '')}" @click="chooseMode(1)">
                <div class="modes">
                    <span>赚钱方法</span>
                </div>
            </div>
        </div>
        <!-- 常见问题 -->
        <div class="problem" v-if="selectMode == 0">
            <div class="about" @click="inAboutTasks">
                <span>关于做任务</span>
                <img src="../../assets/images/right.png" alt="">
            </div>
            <div class="about" @click="inAboutCashOut">
                <span>关于提现</span>
                <img src="../../assets/images/right.png" alt="">
            </div>
            <div class="about" @click="inUserAgreement">
                <span>打款协议</span>
                <img src="../../assets/images/right.png" alt="">
            </div>
        </div>

        <!-- 赚钱方法 -->
        <div class="method" v-else-if="selectMode == 1">
            <div class="about" @click="inTasksMakeMoney">
                <span>做任务赚钱</span>
                <img src="../../assets/images/right.png" alt="">
            </div>
            <div class="about" @click="inApprenticeMakeMoney">
                <span>收徒弟赚钱</span>
                <img src="../../assets/images/right.png" alt="">
            </div>
        </div>

        <img src="../../assets/images/img_53.png" alt="" id="problemIcons"  v-if="selectMode == 0">
        <img src="../../assets/images/img_51.png" alt="" id="methodIcons"  v-else-if="selectMode == 1">

        <div class="others" @click="inCustomerService">问题没解决？联系客服</div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'新手指南',
                selectMode:0
            }
        },
        methods: {
            chooseMode:function(ind){
                this.selectMode = ind
            },
            // 进入 关于做任务
            inAboutTasks:function(){
                this.$router.push('/personal/noviceGuide/aboutTasks')
            },
            // 进入 关于提现
            inAboutCashOut:function(){
                this.$router.push('/personal/noviceGuide/aboutCashOut')
            },
            // 进入 打款协议
            inUserAgreement:function(){
                this.$router.push('/personal/noviceGuide/userAgreement')
            },
            // 进入 做任务赚钱
            inTasksMakeMoney:function(){
                this.$router.push('/personal/noviceGuide/tasksMakeMoney')
            },
            // 进入 收徒弟赚钱
            inApprenticeMakeMoney:function(){
                this.$router.push('/personal/noviceGuide/apprenticeMakeMoney')
            },
            // 进入 我的客服
            inCustomerService:function(){
                this.$router.push('/personal/customerService');
            }
        },
    }
</script>

<style lang="less" scoped>
    #noviceGuide{
        // 选择方式
        .selectMode{
            padding: 10px 0 0;
            display: flex;
            background: #FFFFFF;
            .modesBox{
                width: 50%;
                .modes{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 10px;
                    border-right: 1px solid #E5E5E5;
                    span{
                        font-size: 15px;
                        color: #232524;
                        margin-left: 10px;
                    }
                }
            }
            
        }
        // 常见问题 赚钱方法
        .problem,.method{
            margin: 15px 15px 0;
            width: 345px;
            // height: 150px;
            border: 1px solid #DEDEDE;
            box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
            background: #FFFFFF;
            border-radius: 5px;
            .about{
                padding: 0 15px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                span{
                    font-size: 15px;
                    color: #151515;
                }
                img{
                    width: 18px;
                    height: 18px;
                }
                // &:first-of-type{
                    border-bottom: 1px solid #E5E5E5;
                // }
            }
        }

        #problemIcons{
            width: 175px;
            height: 188px;
            margin: 88px 0 65px 75px;
        }
        #methodIcons{
            width: 216px;
            height: 158px;
            margin: 101px 0 82px 60px;
        }
        .others{
            font-size: 13px;
            color: #999999;
            text-decoration: underline;
            text-align: center;
            padding-bottom: 15px;
        }

    }
</style>